module.exports = __webpack_public_path__ + "img/217.b1010ebe.jpg";